import Image from 'components/Common/Image'
import NumberRating from 'components/Common/NumberRating'
import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'
import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'
import { _searchTileContainerQueryUp } from './_SearchTileBase'
import type { SearchTileLogo } from './SearchTile'

const Container = styled.div<{ $density: SearchTileDensity }>`
  grid-area: content-secondary;
  display: flex;
  flex-direction: column-reverse;
  justify-content: ${props => props.$density === 'compact' ? 'stretch' : 'space-between'};
  align-self: stretch;
  gap: ${rem(8)};
`

const RatingContainer = styled.div`
  display: none;

  ${_searchTileContainerQueryUp.tablet} {
    display: block;
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    display: none;
  }

  ${_searchTileContainerQueryUp.desktop} {
    display: block;
  }
`

const Logo = styled(Image)`
  object-fit: contain;
  margin-inline: auto;
  height: ${rem(90)};
  display: none;

  ${_searchTileContainerQueryUp.tablet} {
    display: block;
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    display: none;
  }

  ${_searchTileContainerQueryUp.desktop} {
    display: block;
  }
`

interface Props extends PropsWithChildren {
  callToAction?: ReactElement
  rating?: App.OfferRating
  logo?: SearchTileLogo
  /**
   * @default default
   */
  density?: SearchTileDensity
}

function _SearchTileContentSecondary({
  children,
  rating,
  logo,
  density = 'default',
}: Props) {
  return <Container $density={density} className={_SearchTileContentSecondary.name}>
    {children}
    {logo && <Logo image={logo.full} width={140} dpr={2} />}
    {rating && <RatingContainer>
      <NumberRating
        rating={rating.score}
        total={rating.reviewsTotal}
        variant="small"
        numberPosition="end"
      />
    </RatingContainer>}
  </Container>
}

export default _SearchTileContentSecondary
